import './Avatar.css';

/**
 * Calcule des initiales lisibles à partir des données disponibles, quel que
 * soit l'endpoint d'origine (certaines réponses API n'incluent pas `initials`
 * ou `full_name` directement sur l'objet imbriqué).
 */
function resolveInitials(user) {
  if (!user) return '·';

  if (user.initials) return user.initials;

  const source = user.full_name || `${user.first_name || ''} ${user.last_name || ''}`.trim();
  if (!source) return '·';

  const parts = source.split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';

  return (first + last).toUpperCase() || '·';
}

/**
 * Avatar de profil : affiche la vraie photo si disponible, sinon les
 * initiales sur un fond navy/or — jamais de "??".
 */
export default function Avatar({ user, size = 'md', className = '' }) {
  const initials = resolveInitials(user);

  if (user?.avatar) {
    return (
      <img
        src={user.avatar}
        alt={user.full_name || 'Avatar'}
        className={`avatar avatar--${size} ${className}`}
      />
    );
  }

  return (
    <div className={`avatar avatar--${size} avatar--initials ${className}`} aria-label={user?.full_name || 'Profil'}>
      {initials}
    </div>
  );
}
